import React from 'react';
import { Modal } from 'antd';

import Button from 'components/Button';
import DF from 'DisplayFramework';
import ScoringDetailV2 from './ScoringDetailV2';

type ScoringModalProps = {
  onCancel: () => void;
  visible: boolean;
  onSuccess?: () => void;
  fromtp?: boolean;
  scoid?: any;
  showAsModal?: boolean;
};

const ScoringModal = (props: ScoringModalProps) => {
  const { onCancel, visible, fromtp, scoid } = props;

  return (
    (<DF.Provider pagcode="contract">
      <Modal
        open={visible}
        onCancel={onCancel}
        width={1500}
        title="Scoring"
        footer={[<Button key="cancel" comcode="cancel" onClick={onCancel} />]}
      >
        <ScoringDetailV2 scoid={scoid} fromtp={fromtp} showAsModal />
      </Modal>
    </DF.Provider>)
  );
};

export default ScoringModal;
